import React, {useCallback,useContext} from 'react'
import { useSelector, useDispatch } from 'react-redux'
import ErrorBoundary from '../errorboundry'
import { deleteInvoice, updateInvoiceField } from '../../actions'
import MerchandiseLineItems from './MerchandiseLineItems'
import { Message } from 'semantic-ui-react'
import { useForm } from '../../../hooks'
import { CustomLoader } from '../../../commonComponents/formComponents/loader'
import InvoiceForm from './invoiceForm'
import ToggleButton from '@commonComponents/formComponents/toggleButton'
import { useValidation } from '../../hooks/useValidation'
import { InvoiceToggleContext } from '@commonComponents/accordion/AccordianInvoice'

const InvoiceItem = (props) => {

  const {state}=useContext(InvoiceToggleContext)
  const active=state[props.invoiceId]

  const dispatch = useDispatch()
  const { invoiceItemIndex, fieldPattern,procedureList } = props
  const { deleteForm, isLoading, saveForm } = useForm("")  
  const { validateError, initItemsTabValidation }= useValidation('items')

  const invoiceId = useSelector((state) => state.InvoicesReducer.invoices[invoiceItemIndex]?.invoiceId) || ''
  // const [activeAccordianIndex, setActiveAccordianIndex] = useState(false)
  const deleteData = useCallback(async () => {
    const response = await deleteForm({ "invoices": [{ invoiceId }] })
    if (response){
      dispatch(deleteInvoice(invoiceId))
      dispatch(initItemsTabValidation())
    } 
  }, [invoiceId, deleteInvoice, dispatch, deleteForm]) 

  const updateData = useCallback((params) => dispatch(updateInvoiceField(invoiceId, params)), [invoiceId])
  const saveData = useCallback((params) => saveForm({ "invoices": [{ "invoiceId": invoiceId, ...params }] },false), [invoiceId, saveForm])

  return (
    <ErrorBoundary>
        <div className={'accordian-section tab-contentInvoice '}>
          <Message>
            {isLoading && <CustomLoader />}
            <ToggleButton
              id={`toggleInvoice-${invoiceId}`}
              title={()=> "INVOICE" }
              toggleId={invoiceId}
              // onClick={() => setActiveAccordianIndex(!activeAccordianIndex)}
              lineNumber={invoiceItemIndex + 1}
              // isActive={activeAccordianIndex}
              confirmationMsg="Invoice"
              onDelete={deleteData}
            />

            {active && (
              <>
                <InvoiceForm
                  invoiceItemIndex={invoiceItemIndex}
                  invoiceId={invoiceId}
                  updateData={updateData}
                  saveData={saveData}
                  fieldPattern={fieldPattern()?.items}
                  validateError={validateError}
                />

                <MerchandiseLineItems
                  key={'merchandise-InvoiceItem' + invoiceId}
                  invoiceItemIndex={invoiceItemIndex}
                  invoiceId={invoiceId}
                  updateInvoiceDataById={updateData}
                  fieldPattern={fieldPattern}
                  validateError={validateError}
                  initItemsTabValidation={initItemsTabValidation}
                  procedureList={procedureList}
                />
              </>
            )}
          </Message>
        </div>
    </ErrorBoundary>
  )
}

export default React.memo(InvoiceItem)
